jQuery(function ($) {
	$(document).ready(function () {
		$(".slick[data-slick]").each(function () {
			//if ($(this).attr('data-slick') != undefined) {
				var data = $(this).attr("data-slick").replaceAll("&#039;", "'").replaceAll("&quot;", "\"");
				$(this).text().replace(/"/g, "'");
				$(this).attr("data-slick", data);
			//}
		});
		
		if ($("#rank-math-toc").length) {
			var elem = new Foundation.SmoothScroll($("#rank-math-toc a"));
			
			$("#rank-math-toc").append('<button class="toc-toggle"></button>');
			
			if ($("#rank-math-toc").hasClass("closed")) {
				$("#rank-math-toc nav").slideUp();
			}
			
			$("#rank-math-toc h2, #rank-math-toc .toc-toggle").on("click", function(e) {
				e.preventDefault();
				$("#rank-math-toc").toggleClass("closed open");
				if ($("#rank-math-toc").hasClass("open")) {
					$("#rank-math-toc nav").slideDown();
				} else {
					$("#rank-math-toc nav").slideUp();
				}
			});
		}

		$(".image-gallery.slick").each(function () {
			var slider = $(this);
			var rows = $(this).hasClass("single-row") ? 1 : 2;
			var perRow = $(this).hasClass("per-row-2") ? 2 : 1;

			// slider.on("init", function (event, slick) {
			// 	if (
			// 		slick.$slider[0].children[0].children[0].children[0].children[1] &&
			// 		slick.$slider[0].children[0].children[0].children[0].children[1]
			// 			.children.length === 0
			// 	) {
			// 		$(this).addClass("single");
			// 	}
			// });
			var responsiveSettings = null;
			if ($(this).hasClass("single-row") && $(this).hasClass("per-row-2")) {
				responsiveSettings = [
					{
						breakpoint: 1024,
						settings: {
							slidesPerRow: 2
						}
					},
					{
						breakpoint: 0,
						settings: {
							slidesPerRow: 1
						}
					}
				];
			}

			slider.slick({
				arrows: true,
				dots: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				// speed: 900,
				autoplay: false,
				// autoplaySpeed: 4000,
				mobileFirst: true,
				infinite: false,
				rows: rows,
				slidesPerRow: perRow,
				// adaptiveHeight: true,
				responsive: responsiveSettings
			});

			slider.slickLightbox();
		});

		$(".image-gallery.slick2").each(function () {
			var slider = $(this);

			slider.slick({
				arrows: true,
				dots: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				mobileFirst: true,
				infinite: false,
				rows: 1,
				slidesPerRow: 2,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesPerRow: 2
						}
					},
					{
						breakpoint: 0,
						settings: {
							slidesPerRow: 1
						}
					}
				]
			});

			slider.slickLightbox();
		});
		
		$(".image-gallery.slick3").each(function () {
			var slider = $(this);
		
			slider.slick({
				arrows: true,
				dots: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				mobileFirst: true,
				infinite: false,
				rows: 1,
				slidesPerRow: 3,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesPerRow: 3
						}
					},
					{
						breakpoint: 0,
						settings: {
							slidesPerRow: 1
						}
					}
				]
			});
		
			slider.slickLightbox();
		});
		
		$(".image-gallery.slick4").each(function () {
			var slider = $(this);
		
			slider.slick({
				arrows: true,
				dots: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				mobileFirst: true,
				infinite: false,
				rows: 1,
				slidesPerRow: 4,
			});
		
			slider.slickLightbox();
		});

// 		$(".image-gallery.lightbox").each(function () {
// 			var slider = $(this);
// 
// 			slider.slickLightbox();
// 		});
		
		$(".lightbox").each(function () {
			$(this).slickLightbox();
		});
	});
});